<template>
<!-- 团体详情 -->
    <div class="team_detail_warp">
        <BaseDetail ref="baseDetail">
            <template slot="cont" scope="{info}">
                <div class="cont_warp" >
                    <el-image class="cont_top_img" :src="info.image" ></el-image>
                    <div class="top_info">
                        <div class="cont_top_title">{{info.teamName}}</div>
                        <div class="behavior_box">
                            <div>浏览 0 </div>
                            <div class="behavior_list">
                                <div class="behavior_item" @click="praise">
                                    <svg-icon icon-class="thumb" :class="operCount.ydz? 'active_icon': ''" class="item_icon" />
                                        {{operCount.dzs}}
                                </div>
                                <div class="behavior_item" @click="collect">
                                    <i class="el-icon-star-off item_icon" :class="operCount.ysc? 'active_icon': ''"  />
                                        {{operCount.scs}}
                                </div>
                                <!-- <div class="behavior_item">
                                    <i class="el-icon-share item_icon"/> 分享
                                </div> -->
                            </div>
                            <el-button type="primary" @click="addTeam">{{'加入团体'}}</el-button>
                            <!-- <el-button  type="info">{{info.statusName}}</el-button> -->
                        </div>
                        <div class="top_line">时间：{{formatDate(info.startTime)}} ~ {{formatDate(info.endTime)}}</div>
                        <div class="top_line">电话：{{info.leaderTel}}</div>
                        <div class="top_line">地址：{{info.addr}}</div>
                        <div class="activity_content" v-html="info.info"></div>
                    </div>
                </div>
            </template>
        </BaseDetail>
    </div>
</template>

<script>
import BaseDetail from '@c/BaseDetail'
import { formatDate } from "@u/index.js";
import { post } from '@u/request'
import { mapGetters } from 'vuex'

export default {
    name: 'teamDetail',
    components: {
        BaseDetail
    },
    data() {
        return {
            operCount: {}
        }
    },
    computed: {
        ...mapGetters([
            'readerId',
        ]),
        contentId() {
            return this.$route.params.id
        }
    },
    methods: {
        formatDate(date) {
            return formatDate(date)
        },
        async addTeam() {
            if (!this.readerId) {
                this.$store.commit('SET_VISIBLE_LOGIN',true);
                return
            }
            if (this.operCount.ybm) {
                this.$message.success('已经加入团体啦！')
                return;
            }
            const params = {
                readerId: this.readerId,
                performanceId: this.contentId
            }
            const { code } = await post('resource/myteam/add', params);
            if (code == 0) {
                this.$message.success('加入团体成功！')
            }
        },
        async praise() {
            if (!this.readerId) {
                this.$store.commit('SET_VISIBLE_LOGIN',true);
                return
            }
            if (this.operCount.ydz) {
                this.$message.success('已经点赞啦！');
                return;
            }
          
            const params = {
                readerId: this.readerId,
                performanceId: this.contentId
            }
            const { code } = await post('resource/praise/add', params);
            if (code == 0) {
                this.$message.success('点赞成功！')
            }
        },
        async collect() {
            if (!this.readerId) {
                this.$store.commit('SET_VISIBLE_LOGIN',true);
                return
            }
              if (this.operCount.ysc) {
                this.$message.success('已经收藏啦！');
                return;
            }
            const params = {
                readerId: this.readerId,
                performanceId: this.contentId
            }
            const { code } = await post('resource/collect/add', params);
            if (code == 0) {
                this.$message.success('收藏成功！')
            }
        },
        async operinfo() {
            const params = {
                readerId: this.readerId,
                performanceId: this.contentId
            }
            const { data } = await post('resource/showapi/operinfo', params);
            this.operCount = data;
        }
    },
    mounted() {
        this.$refs.baseDetail.videoLoad('performanceinfo')
        this.$refs.baseDetail.loadCommentList('performanceId')
        this.operinfo()
    }
}
</script>

<style scoped lang="scss">
.team_detail_warp {
    background: #f8f8f8;
    min-height: calc(100vh - 315px);
    .cont_warp {
        .cont_top_img {
            width: 100%;
            height: 392px;
            border-radius: 5px 5px 0 0;
        }
     
        .top_info {
            padding: 19px 30px 35px 30px;
            color: #656567;
            line-height: 1;
            font-size: 20px;
        }
        .cont_top_title {
            font-size: 24px;
            font-weight: 800;
            color: #000;
        }
        .top_line {
            padding-top: 16px;
        }
        .activity_content {
            margin-top: 50px;
        }
        .behavior_box {
            display: flex;
            align-items: center;
            font-size: 20px;
            color: #777;
            padding: 27px 0 20px;
        }
        .behavior_list {
            margin-right: auto;
            margin-left: 20px;
            display: flex;
            .behavior_item {
                width: 118px;
                height: 47px;
                line-height: 47px;
                text-align: center;
                border-radius: 5px;
                background: #f5f5f5;
                cursor: pointer;
                margin-left: 18px;
            }
        }
        .item_icon {
            font-size: 23px;
        }
    }
    .active_icon {
        color: #a80000;
    }
}
</style>